import ClockSVG from "@/assets/images/clock-illustration.svg";
import { PlusIconSVG } from "@/assets/svg";

const NoDataContainer = ({
  title,
  description,
  buttonLabel,
  onButtonClick,
}: {
  title: string;
  description?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="mb-10">
        <img src={ClockSVG} alt="No projects yet" className="w-full h-full" />
      </div>
      <p className="text-[28px] font-[600] text-[#212121] mb-[16px]">{title}</p>
      {description && (
        <p className="text-[#9e9e9e] text-[18px] mb-[24px] text-center">
          {description}
        </p>
      )}
      {buttonLabel && onButtonClick && (
        <button
          onClick={onButtonClick}
          className="flex w-[208px] h-[34px] items-center justify-center gap-2 px-4 py-2 bg-[#73B5C5] text-white rounded-md hover:bg-[#5a9aaa] transition-colors"
        >
          <span>{buttonLabel}</span>
          <PlusIconSVG />
        </button>
      )}
    </div>
  );
};

export default NoDataContainer;
